import { Ship, MapPin } from "lucide-react";

export default function RouteMap() {
  return (
    <section
      data-testid="route-map-section"
      className="relative bg-[#0B1F4D] text-white py-20 lg:py-24 overflow-hidden"
    >
      {/* Decorative grid */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#D61F26] mb-3">
            Nuestra Ruta
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight">
            De Nueva York a tu puerta en RD
          </h2>
        </div>

        {/* Map with animated ship overlay */}
        <div className="relative max-w-4xl mx-auto">
          <img
            src="/route-map.png"
            alt="Ruta de envío de Nueva York a República Dominicana"
            className="w-full h-auto block"
          />

          {/* Animated ship that travels along the curve */}
          <svg
            viewBox="0 0 1000 600"
            preserveAspectRatio="none"
            className="absolute inset-0 w-full h-full pointer-events-none"
            aria-hidden
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Invisible motion path matching the dashed curve in the image */}
            <path
              id="ship-route"
              d="M 415,205 Q 700,260 540,560"
              fill="none"
              stroke="none"
            />
            {/* Ship */}
            <g>
              <animateMotion dur="7s" repeatCount="indefinite" rotate="auto">
                <mpath href="#ship-route" />
              </animateMotion>
              <g transform="translate(-14,-12)">
                <rect x="2" y="8" width="24" height="10" rx="2" fill="#FBD300" stroke="#0B1F4D" strokeWidth="0.6" />
                <polygon points="2,18 26,18 23,24 5,24" fill="#FBD300" stroke="#0B1F4D" strokeWidth="0.6" />
                <rect x="8" y="3" width="3" height="5" fill="#fff" />
                <rect x="13" y="0" width="3" height="8" fill="#fff" />
                <rect x="18" y="3" width="3" height="5" fill="#fff" />
              </g>
            </g>
          </svg>
        </div>

        {/* Stats */}
        <div className="mt-12 grid grid-cols-3 gap-6 max-w-3xl mx-auto">
          <div className="text-center">
            <Ship className="w-7 h-7 mx-auto mb-2 text-[#D61F26]" strokeWidth={2} />
            <div className="font-display text-2xl sm:text-3xl font-black">15-21 días</div>
            <div className="text-xs uppercase tracking-wider text-white/60 mt-1">Tiempo promedio</div>
          </div>
          <div className="text-center">
            <MapPin className="w-7 h-7 mx-auto mb-2 text-[#D61F26]" strokeWidth={2} />
            <div className="font-display text-2xl sm:text-3xl font-black">100%</div>
            <div className="text-xs uppercase tracking-wider text-white/60 mt-1">Cobertura RD</div>
          </div>
          <div className="text-center">
            <div className="text-2xl mb-1">🇺🇸 → 🇩🇴</div>
            <div className="font-display text-2xl sm:text-3xl font-black">+1,500 mi</div>
            <div className="text-xs uppercase tracking-wider text-white/60 mt-1">Conectados con amor</div>
          </div>
        </div>
      </div>
    </section>
  );
}
